declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

// Google Ads Customer Tag ID
export const GOOGLE_ADS_TAG_ID = 'AW-8254902853';

/**
 * Tracks a custom event in Google Analytics / Google Ads.
 */
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  } else {
    console.log('[Analytics Event]:', action, category, label, value);
  }
};

/**
 * Tracks a Google Ads conversion event using the Google Ads conversion label.
 */
export const trackConversion = (conversionLabel: string, value?: number, currency = 'UAH') => {
  if (typeof window !== 'undefined' && window.gtag) {
    const sendTo = conversionLabel.includes('/') 
      ? conversionLabel 
      : `${GOOGLE_ADS_TAG_ID}/${conversionLabel}`;
      
    window.gtag('event', 'conversion', {
      send_to: sendTo,
      value: value,
      currency: currency,
    });
    console.log('[Analytics Conversion Sent]:', sendTo, value, currency);
  } else {
    console.log('[Analytics Conversion Dry Run]:', conversionLabel, value, currency);
  }
};
